@if (mmmTooltip.length > 0) {
  <div>
    <m-tooltip
      [content]="mmmTooltip"
      position="bottom"
      [tooltipOptions]="{
        positionTop: 15,
        showDelay: 400,
      }">
      <div class="mmm-banner" (click)="navigateToMmmDoc()">
        <div class="mmm-banner-shimmer"></div>
        <div class="mmm-banner-content">
          <img
            alt="MIM Sparkles"
            src="assets/images/home-page/sparkles.svg"
            width="23px"
            class="pr-2" />
          <div>
            Powered by
            <span class="text-gray-1000"
              >your Incrementality Tests and MMM</span
            >
          </div>
        </div>
      </div>
    </m-tooltip>
  </div>
} @else {
  <div class="mmm-banner" (click)="navigateToMmmDoc()">
    <div class="mmm-banner-shimmer"></div>
    <div class="mmm-banner-content">
      <img
        alt="MIM Sparkles"
        src="assets/images/home-page/sparkles.svg"
        width="23px"
        class="pr-2" />
      <div>
        Powered by
        <span class="text-gray-1000">your Incrementality Tests and MMM</span>
      </div>
    </div>
  </div>
}
